













































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { Coupon } from "@/models/coupon";
import { edit as EditCoupon, disable as DisableCoupon } from "@/dialogs/coupon";
const log = NSLog("view/ManageCoupons");

@Component({
  components: {
    loader,
    EditCoupon,
    DisableCoupon,
  },
})
export default class ListRules extends Vue {
  get visibleCounpons() {
    return this.coupons.filter(
      (v: Coupon) => this.includeDisabled || Number(v.active)
    );
  }

  @Mutation("setLastErr") public setLastErr: any;

  public headers = [
    { text: "Trigger", value: "trigger" },
    {
      text: "Description",
      align: "left",
      sortable: true,
      value: "description",
    },
    { text: "Action", value: "action" },
    { text: "", value: "-" },
  ];
  private loading = false;
  private saving = false;
  private coupons: Coupon[] = [];
  private includeDisabled = false;
  private pagination: any = {
    // descending: boolean",
    // page: number",
    rowsPerPage: -1,
    sortBy: "created_at",
    // totalItems: number"
  };

  private editCoupon: Coupon | boolean = false;
  private disableCoupon: Coupon | boolean = false;

  public created() {
    console.log("list created");
    this.refreshCoupons();
  }

  public couponUpdated(coupon: Coupon | boolean) {
    this.editCoupon = false;
    this.disableCoupon = false;
    if (!coupon) {
      return;
    }

    this.refreshCoupons();
  }

  private async refreshCoupons() {
    this.loading = true;
    try {
      this.coupons = await billingApi.listCoupons();
    } catch (err) {
      log("err", err);
    }
    this.loading = false;
  }
}
